import React from 'react';
import { DOMAIN_CONFIG } from '../config';
import { Briefcase, Users, Layers, GraduationCap, ArrowUpRight } from 'lucide-react';

const icons = [Briefcase, Users, Layers, GraduationCap];

export const UseCases: React.FC = () => {
  return (
    <section id="use-cases" className="py-20 md:py-28 relative bg-[#060a16]/60 border-y border-slate-800/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-slate-900 border border-slate-700/80 text-cyan-400 text-xs font-mono mb-4">
            <Layers className="w-3.5 h-3.5" />
            <span>BLUEPRINT ARCHITECTURES</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white tracking-tight">
            High-Impact Use Cases for <span className="text-emerald-400">{DOMAIN_CONFIG.domainName}</span>
          </h2>
          <p className="mt-4 text-base sm:text-lg text-slate-300">
            Whether accelerating lead generation for an elite agency or building a developer community, this domain gives your venture instant authority from day one.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {DOMAIN_CONFIG.useCases.map((useCase, index) => {
            const Icon = icons[index % icons.length];
            return (
              <div
                key={useCase.title}
                className="glass-panel rounded-2xl p-7 relative border border-slate-800/80 hover:border-slate-700 transition-all group"
              >
                <div className="flex items-start justify-between mb-5">
                  <div className="w-12 h-12 rounded-xl bg-slate-800/70 border border-slate-700/60 flex items-center justify-center text-emerald-400 group-hover:scale-105 group-hover:bg-emerald-500/10 group-hover:border-emerald-500/30 transition-all">
                    <Icon className="w-6 h-6" />
                  </div>
                  <span className="px-3 py-1 rounded-full bg-slate-900 text-slate-400 text-xs font-mono border border-slate-800">
                    {useCase.category}
                  </span>
                </div>

                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-emerald-300 transition-colors">
                  {useCase.title}
                </h3>
                <p className="text-slate-300 text-sm leading-relaxed mb-6">
                  {useCase.description}
                </p>

                <div className="pt-4 border-t border-slate-800/60 flex items-center justify-between text-xs">
                  <span className="text-slate-500 uppercase font-mono tracking-wider">Business Impact:</span>
                  <span className="font-semibold text-emerald-400 flex items-center gap-1">
                    {useCase.potential}
                    <ArrowUpRight className="w-3.5 h-3.5" />
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
